import PageHeader from "@/components/shared/PageHeader";

export default function Accessibility() {
  return (
    <>
      <PageHeader overline="Legal" title="Accessibility statement." />
      <section className="ccdr-section">
        <div className="ccdr-narrow ccdr-prose">
          <p className="ccdr-lead">
            The Centre for Climate and Disaster Resilience is committed to making this website accessible to all
            visitors, in line with the Web Content Accessibility Guidelines (WCAG) 2.1 at the AA level.
          </p>
          <h2 className="ccdr-h3 mt-12 mb-4">Our approach</h2>
          <p>
            The site uses semantic HTML, sufficient colour contrast, scalable typography, and full keyboard navigation.
            Interactive components from the Shadcn UI library include accessible-name and ARIA support out of the box.
            Forms use clear labels and associated error messages.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">Known limitations</h2>
          <p>
            Where third-party content (such as embedded video) is included, full accessibility is dependent on the
            provider. The Centre will work with providers to address gaps as they are identified.
          </p>
          <h2 className="ccdr-h3 mt-10 mb-4">Tell us</h2>
          <p>
            If you encounter an accessibility barrier on this site, please contact the Centre using the contact form on
            the Get Involved page. Reports are taken seriously and reviewed promptly.
          </p>
          <p className="text-sm text-[#9CA3AF] mt-12">
            Standard: WCAG 2.1 AA · Last reviewed June 2026.
          </p>
        </div>
      </section>
    </>
  );
}
